// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Qd","title":"Rd","nav":"Sd","flexCell":"Td","facetLink":"Ud"};